<template>
<v-container :class="{ smallDevice: $vuetify.breakpoint.xs }">
	<v-container grid-list-lg>
		<v-layout :class="$vuetify.breakpoint.xs ? 'column' : 'row'" >
			<v-flex xs12 md3 >
				<v-layout column>
					<v-flex d-flex justify-center align-center>
						<avatar
							:avatar="worker.avatar"
							:upload-path="uploadPath"
							@delete="deleteAvatar"
							@setAvatar="setAvatar"
							:show-upload="permission"
						/>
					</v-flex>
					<v-flex v-if="permission">
						<DownloadDocument />
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md9>
				<v-layout column>
					<v-flex>
						<v-layout row>
							<v-flex xs12 sm6 md4>
								<TextItem :label="$t('workers.firstname')"
									:text="worker.firstname"
								/>
							</v-flex>

							<v-flex xs12 sm6 md4>
								<TextItem :label="$t('workers.lastname')"
									:text="worker.lastname"
								/>
							</v-flex>

							<v-flex xs12 sm6 md4>
								<TextItem :label="$t('workers.employer_name')"
									:text="worker.employer_name"
								/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex>
						<v-layout row fill-height align-end>
							<v-flex xs12 sm4 md4>
								<TextItem :label="$t('workers.birth_date')"
									:text="worker.birth_date"
								/>
							</v-flex>

							<v-flex xs12 sm4 d-flex>
								<TextItem :label="$t('workers.citizenship')"
									:text="worker.citizenship_name"
								/>
							</v-flex>

							<v-flex xs12 sm4 md4 d-flex>
								<TextItem :label="$t('workers.civil_status')"
									:text="worker.civil_status ? $t('workers.' + worker.civil_status) : ''"
								/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex>
						<v-layout row fill-height align-end>
							<v-flex xs12 sm4 md4>
								<TextItem :label="$t('workers.rodni_chisla')"
									:text="worker.rodni_chisla"
								/>
							</v-flex>

							<v-flex xs12 sm4 d-flex>
								<TextItem :label="$t('workers.passport_number')"
									:text="worker.passport_number"
								/>
							</v-flex>

							<v-flex xs12 sm4 md4 d-flex>
								<TextItem :label="$t('workers.agency_name')"
									:text="worker.agency_name"
								/>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</v-container>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import DownloadDocument from '../../components/DownloadDocument'
import DatePicker from '../../components/DatePicker'
import TextItem from '../../components/TextItem'
import Avatar from '../../components/Avatar'

export default {
	computed: {
		...mapGetters({
			hasRole: 'auth/hasRole'
		}),
		uploadPath() {
			return `/workers/${this.$route.params.workerId}/upload-avatar`
		},
		worker() {
			return this.$store.state.workers.preview
		},
		permission() {
			return !this.hasRole('canPrepay')
		}
	},
	methods: {
		deleteAvatar() {
			this.$store.dispatch('workers/deleteAvatar')
				.then(() => {
					this.$store.dispatch('workers/fetchPreview')
				})
		},
		...mapMutations({
			setAvatar: function () {
				'workers/setAvatar'
				this.$store.dispatch('workers/fetchPreview')
			}
		}),
		getAvatar: name => Vue.http.options.root + '/files/' + name,
	},
	components: {
		DownloadDocument,
		DatePicker,
		TextItem,
		Avatar
	}
}
</script>

<style scoped>
.smallDevice {
	padding: 0;
}
</style>
